import axios from "axios";

export function fetchForm(atmCampaign) {
  return axios.post("/external/sbk/fields", { atmCampaign });
}

export function sendRegistrationExistingAccount(payload) {
  return axios.post("/external/sbk/register-existing", payload);
}

export function sendRegistrationNewAccount(payload) {
  return axios.post("/external/sbk/register-new", payload);
}

export function sendActivationToken(payload) {
  return axios.post("/external/sbk/activate", payload);
}

export function resendActivation(email) {
  return axios.post("/external/sbk/resend-activation-link", { email: email });
}

export function startResetPassword(email) {
  return axios.post("/external/sbk/reset-password", { email: email });
}

export function setNewPassword(token, password) {
  return axios.post("/external/sbk/reset-password/set", {
    token: token,
    password: password,
  });
}

export function fetchSites() {
  return axios.post("/external/sbk/sites");
}
